import React, { useState, useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  ChevronDownIcon,
  TrashIcon,
  CheckIcon,
} from "@heroicons/react/20/solid";

import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";

function App() {
  // const [tableData, setTableData] = useState({ columns: [], rows: [] });

  const [filters, setFilters] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [newColumn, setNewColumn] = useState("");
  const [newRow, setNewRow] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [editingCell, setEditingCell] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [tableData, setTableData] = useState({
    columns: ["First Name", "Last Name", "Major"],
    rows: [
      {
        id: "1",
        data: {
          "First Name": "John",
          "Last Name": "Doe",
          Major: "Computer Science",
        },
      },
      {
        id: "2",
        data: {
          "First Name": "Jane",
          "Last Name": "Smith",
          Major: "Electrical Engineering",
        },
      },
    ],
  });

  const [filteredRows, setFilteredRows] = useState(tableData.rows);

  // Remove fetchTableData and useEffect since we're not fetching from an API anymore

  const handleAddColumn = async (columnName, aiPopulate = false) => {
    setTableData((prevData) => ({
      ...prevData,
      columns: [...prevData.columns, columnName],
      rows: prevData.rows.map((row) => ({
        ...row,
        data: {
          ...row.data,
          [columnName]: "",
        },
      })),
    }));

    if (aiPopulate) {
      await handlePopulateColumn(columnName);
    }
    setNewColumn("");
  };

  const handleAddRow = (row) => {
    setTableData((prevData) => ({
      ...prevData,
      rows: [...prevData.rows, row],
    }));
    setNewRow({});
  };

  const handleDeleteRow = (rowId) => {
    setTableData((prevData) => ({
      ...prevData,
      rows: prevData.rows.filter((row) => row.id !== rowId),
    }));
  };

  const handleDeleteColumn = (columnName) => {
    setTableData((prevData) => ({
      ...prevData,
      columns: prevData.columns.filter((col) => col !== columnName),
      rows: prevData.rows.map((row) => ({
        ...row,
        data: Object.fromEntries(
          Object.entries(row.data).filter(([key]) => key !== columnName)
        ),
      })),
    }));
  };

  const handleUpdateRow = (updatedRow) => {
    setTableData((prevData) => ({
      ...prevData,
      rows: prevData.rows.map((row) =>
        row.id === updatedRow.id ? updatedRow : row
      ),
    }));
  };

  const handleCellEdit = (row, column, value) => {
    const updatedRow = {
      ...row,
      data: { ...row.data, [column]: value },
    };
    handleUpdateRow(updatedRow);
  };

  const handleDeleteSelected = () => {
    setTableData((prevData) => ({
      ...prevData,
      rows: prevData.rows.filter((row) => !selectedRows.includes(row.id)),
    }));
    setSelectedRows([]);
  };

  const handleRenameColumn = (oldName, newName) => {
    setTableData((prevData) => ({
      ...prevData,
      columns: prevData.columns.map((col) => (col === oldName ? newName : col)),
      rows: prevData.rows.map((row) => ({
        ...row,
        data: Object.fromEntries(
          Object.entries(row.data).map(([key, value]) => [
            key === oldName ? newName : key,
            value,
          ])
        ),
      })),
    }));
  };

  // useEffect(() => {
  //   fetchTableData();
  // }, []);

  // const fetchTableData = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:8000/api/table");
  //     setTableData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching table data:", error);
  //   }
  // };

  // const handleAddColumn = async (columnName, aiPopulate = false) => {
  //   try {
  //     await axios.post("http://localhost:8000/api/columns", {
  //       name: columnName,
  //     });
  //     fetchTableData();
  //     if (aiPopulate) {
  //       console.log("AI Populating column", columnName);
  //       await handlePopulateColumn(columnName);
  //     }
  //     fetchTableData();
  //     setNewColumn("");
  //   } catch (error) {
  //     console.error("Error adding column:", error);
  //   }
  // };

  // const handleAddRow = async (row) => {
  //   try {
  //     await axios.post("http://localhost:8000/api/rows", row);
  //     fetchTableData();
  //     setNewRow({});
  //   } catch (error) {
  //     console.error("Error adding row:", error);
  //   }
  // };

  // const handleDeleteRow = async (rowId) => {
  //   try {
  //     await axios.delete(`http://localhost:8000/api/rows/${rowId}`);
  //     fetchTableData();
  //   } catch (error) {
  //     console.error("Error deleting row:", error);
  //   }
  // };

  // const handleDeleteColumn = async (columnName) => {
  //   try {
  //     await axios.delete(`http://localhost:8000/api/columns/${columnName}`);
  //     fetchTableData();
  //   } catch (error) {
  //     console.error("Error deleting column:", error);
  //   }
  // };

  // const handleUpdateRow = async (updatedRow) => {
  //   try {
  //     await axios.put(
  //       `http://localhost:8000/api/rows/${updatedRow.id}`,
  //       updatedRow
  //     );
  //     fetchTableData();
  //   } catch (error) {
  //     console.error("Error updating row:", error);
  //   }
  // };

  // const handleCellEdit = (row, column, value) => {
  //   const updatedRow = {
  //     ...row,
  //     data: { ...row.data, [column]: value },
  //   };
  //   handleUpdateRow(updatedRow);
  // };

  // const handleDeleteSelected = async () => {
  //   try {
  //     await Promise.all(
  //       selectedRows.map((rowId) =>
  //         axios.delete(`http://localhost:8000/api/rows/${rowId}`)
  //       )
  //     );
  //     setSelectedRows([]);
  //     fetchTableData();
  //   } catch (error) {
  //     console.error("Error deleting rows:", error);
  //   }
  // };
  const handlePopulateColumn = async (columnName) => {
    try {
      // First update all rows with "Generating..." message
      setTableData((prevData) => ({
        ...prevData,
        rows: prevData.rows.map((row) => ({
          ...row,
          data: {
            ...row.data,
            [columnName]: "Generating...",
          },
        })),
      }));

      // Process each row
      const updatedRows = await Promise.all(
        tableData.rows.map(async (row) => {
          const context = Object.entries(row.data)
            .map(([key, value]) => `${key}: ${value}`)
            .join(", ");

          // Direct OpenAI API call
          const response = await fetch(
            "https://api.openai.com/v1/chat/completions",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`, // Make sure to add your API key to .env
              },
              body: JSON.stringify({
                model: "gpt-3.5-turbo",
                messages: [
                  {
                    role: "system",
                    content: `Given the following information about a person: ${context}
                         Please generate a suitable value for their ${columnName}.
                         Provide only the value, no explanation.
                         Keep the response concise and relevant.`,
                  },
                ],
              }),
            }
          );

          const data = await response.json();

          return {
            ...row,
            data: {
              ...row.data,
              [columnName]: data.choices[0].message.content,
            },
          };
        })
      );

      // Update state with all the new values at once
      setTableData((prevData) => ({
        ...prevData,
        rows: updatedRows,
      }));
    } catch (error) {
      console.error("Error populating column:", error);
      // Revert back to empty values if there's an error
      setTableData((prevData) => ({
        ...prevData,
        rows: prevData.rows.map((row) => ({
          ...row,
          data: {
            ...row.data,
            [columnName]: "Error generating value",
          },
        })),
      }));
    }
  };
  // const handlePopulateColumn = async (columnName) => {
  //   try {
  //     const tempRows = tableData.rows.map((row) => ({
  //       ...row,
  //       data: {
  //         ...row.data,
  //         [columnName]: "Generating...",
  //       },
  //     }));

  //     // Update all rows with temporary value
  //     await Promise.all(tempRows.map((row) => handleUpdateRow(row)));
  //     fetchTableData();
  //     const rowsWithData = tableData.rows.map(async (row) => {
  //       const context = Object.entries(row.data)
  //         .map(([key, value]) => `${key}: ${value}`)
  //         .join(", ");

  //       const response = await axios.post(
  //         "http://localhost:8000/api/generate-value",
  //         {
  //           columnName,
  //           context,
  //         }
  //       );

  //       const updatedRow = {
  //         ...row,
  //         data: {
  //           ...row.data,
  //           [columnName]: response.data.value,
  //         },
  //       };

  //       await handleUpdateRow(updatedRow);
  //       fetchTableData();
  //       // return {
  //       //   ...row,
  //       //   data: {
  //       //     ...row.data,
  //       //     [columnName]: response.data.value,
  //       //   },
  //       // };
  //     });

  //     // const updatedRows = await Promise.all(rowsWithData);

  //     // await Promise.all(updatedRows.map((row) => handleUpdateRow(row)));

  //     // fetchTableData();
  //   } catch (error) {
  //     console.error("Error populating column:", error);
  //   }
  // };

  // const handleRenameColumn = async (oldName, newName) => {
  //   try {
  //     await axios.put(`http://localhost:8000/api/columns/rename`, {
  //       old_name: oldName,
  //       new_name: newName,
  //     });
  //     fetchTableData();
  //   } catch (error) {
  //     console.error("Error renaming column:", error);
  //   }
  // };
  const handleToggleHiddenColumn = (column) => {
    if (hiddenColumns.includes(column)) {
      setHiddenColumns(hiddenColumns.filter((col) => col !== column));
    } else {
      setHiddenColumns([...hiddenColumns, column]);
    }
  };
  const ColumnHeaderMenu = ({ column, onDelete, onRename }) => {
    const [newName, setNewName] = useState(column);

    return (
      <div className="w-full h-full">
        <Menu>
          <MenuButton className="w-full h-full py-3 ">
            <div className="flex items-center h-full w-full jutify-between">
              <span className="ml-4 font-medium">{column}</span>
              <ChevronDownIcon className="h-4 w-4" />
            </div>
          </MenuButton>
          {/* <div className="flex items-center bg-[#1f1f1f]">
          <span className="ml-4 font-medium">{column}</span>
          <MenuButton className="ml-1 text-gray-400 hover:text-gray-600">
            <ChevronDownIcon className="h-4 w-4" />
          </MenuButton>
        </div> */}
          <MenuItems
            transition
            anchor="bottom start"
            className="bg-dark-gray border-border-gray border-[1px] rounded-md text-text-gray w-[400px]"
          >
            <MenuItem
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className="w-full p-2">
                <input
                  className="w-full border-border-gray border-[1px]  bg-light-gray rounded-md p-2 text-[16p focus:outline-none focus:bg-none"
                  type="text"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && newName) {
                      onRename(column, newName);
                    }
                    if (e.key === "Escape") {
                      setNewName(column);
                    }
                    if (e.key === " ") {
                      e.stopPropagation();
                      e.preventDefault();
                      setNewName(newName + " ");
                    }
                  }}
                  autoFocus
                />
              </div>
            </MenuItem>
            <MenuItem className="w-full mt-4 border-b-1 border-border-gray mb-4">
              <div className="w-full p-2">
                <button
                  className="w-full bg-highlight rounded-md py-2 text-white transition-all duration-300 hover:bg-highlight/80"
                  onClick={() => {
                    if (newName) {
                      onRename(column, newName);
                    } else {
                      setNewName(column);
                    }
                  }}
                >
                  Save
                </button>
              </div>
            </MenuItem>
            <MenuItem className="border-t border-border-gray">
              <div className="w-full p-2">
                <button
                  onClick={() => handleToggleHiddenColumn(column)}
                  className="w-full p-2 hover:bg-[#303030] rounded-md transition-all duration-300 text-[#fafafa] text-[15px] flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-3"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                  <span className="ml-2">Hide</span>
                </button>
              </div>
            </MenuItem>
            <MenuItem className="">
              <div className="w-full pb-2 px-2">
                <button
                  onClick={() => onDelete(column)}
                  className="w-full p-2 hover:bg-[#303030] rounded-md transition-all duration-300 text-[#d03839] text-[15px] flex items-center"
                >
                  <TrashIcon className="h-3 w-3 mr-2" />
                  Delete
                </button>
              </div>
            </MenuItem>
          </MenuItems>
        </Menu>
      </div>
    );
  };

  const AddColumnButton = () => {
    const [newColumnName, setNewColumnName] = useState("");
    const [useAI, setUseAI] = useState(false);

    return (
      <Menu>
        <MenuButton className="flex items-center text-text-gray border-r border-border-gray py-1 w-full h-full">
          <div className="w-full text-[24px]">+</div>
        </MenuButton>

        <MenuItems
          transition
          anchor="bottom-start"
          className="bg-dark-gray border-border-gray border-[1px] rounded-md text-text-gray w-[400px] p-2"
        >
          <MenuItem>
            <div className="text-[24px] font-medium text-[#d4d4d4]">
              Add column
            </div>
          </MenuItem>
          <MenuItem>
            <div className="text-[16px] text-text-gray mb-4">
              Describe the column you want to create
            </div>
          </MenuItem>
          <MenuItem
            as="div"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <input
              type="text"
              value={newColumnName}
              onChange={(e) => {
                setNewColumnName(e.target.value);
              }}
              placeholder="Column name"
              className="w-full border-border-gray border-[1px]  bg-light-gray rounded p-2 text-[16p focus:outline-none focus:bg-none"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.stopPropagation();
                  e.preventDefault();
                  setNewColumnName(newColumnName + " ");
                }
              }}
            />
          </MenuItem>

          <MenuItem as="div" className="flex items-center justify-between px-2 py-3">
            <span className="text-text-gray">AI</span>
            <div
              className={`relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer transition-colors ease-in-out duration-200 ${
                useAI ? "bg-highlight" : "bg-border-gray"
              }`}
              onClick={(e) => {
                e.preventDefault();
                setUseAI(!useAI);
              }}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition ease-in-out duration-200 ${
                  useAI ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </div>
          </MenuItem>

          <MenuItem>
            <button
              className="w-full bg-highlight rounded-md py-2 text-white"
              onClick={async (e) => {
                e.preventDefault();
                if (newColumnName) {
                  await handleAddColumn(newColumnName, useAI);
                }
              }}
            >
              Add Column
            </button>
          </MenuItem>

          <MenuItem>
            <button
              className="w-full text-[#d03839] mt-4 mb-2 py-2 hover:bg-[#303030] rounded-md transition-all duration-300"
              onClick={(e) => {
                setNewColumnName("");
              }}
            >
              Cancel
            </button>
          </MenuItem>
        </MenuItems>
      </Menu>
    );
  };

  const HiddenColumnsMenu = () => {
    return (
      <Menu>
        <MenuButton className="data-[active]:bg-[#303030] flex items-center gap-2 text-[#fafafa] border border-border-gray rounded-md py-2 px-3 transition-all duration-300 hover:bg-[#303030]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
            />
          </svg>
        </MenuButton>
        <MenuItems
          transition
          anchor="bottom end"
          className="bg-dark-gray border-border-gray border rounded-md text-text-gray"
        >
          <MenuItem>
            <div className="text-[14px] w-full border-b border-border-gray p-2 text-[#d4d4d4] pr-12 text-nowrap">
              Hide columns
            </div>
          </MenuItem>
          {tableData.columns.map((column) => (
            <MenuItem
              as="div"
              key={column}
              className="text-nowrap flex items-center transition-all duration-300 hover:bg-[#303030] m-1 cursor-pointer rounded-md"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleToggleHiddenColumn(column);
              }}
            >
              {!hiddenColumns.includes(column) ? (
                <div className="flex items-center text-[#d4d4d4] ml-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m4.5 12.75 6 6 9-13.5"
                    />
                  </svg>
                </div>
              ) : (
                <div className="h-4 w-4 mr-2 ml-2" />
              )}
              <div className="text-[14px] w-full text-[#d4d4d4] py-2 pl-2 pr-12">
                {column}
              </div>
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    );
  };
  const [filterRows, setFilterRows] = useState([
    { id: uuidv4(), column: "", operator: "Contains", value: "" },
  ]);
  const FiltersMenu = ({ filterRows, setFilterRows }) => {
    const handleAddFilter = () => {
      setFilterRows([
        ...filterRows,
        {
          id: uuidv4(),
          column: "",
          operator: "Contains",
          value: "",
        },
      ]);
    };
    const handleRemoveFilter = (id) => {
      setFilterRows(filterRows.filter((row) => row.id !== id));
    };
    const handleFilterChange = (id, field, value) => {
      setFilterRows(
        filterRows.map((row) =>
          row.id === id ? { ...row, [field]: value } : row
        )
      );
    };
    const handleResetFilters = () => {
      setFilterRows([
        { id: uuidv4(), column: "", operator: "Contains", value: "" },
      ]);
    };
    return (
      <Menu as="div" className="relative">
        <MenuButton className="flex items-center gap-2 text-[#fafafa] border border-border-gray rounded-md py-2 px-3 transition-all duration-300 hover:bg-[#303030]">
          Filters
        </MenuButton>
        <MenuItems
          className="absolute top-full right-0 bg-dark-gray p-6 rounded-lg border border-border-gray"
          style={{ zIndex: 50 }}
        >
          <MenuItem>
            <h2 className="text-2xl text-white mb-4">Filters</h2>
          </MenuItem>
          <MenuItem>
            <div className="">
              {filterRows.map((filter) => (
                <div key={filter.id} className="flex items-center gap-4 mb-4">
                  <div className="text-text-gray">Where</div>

                  <Menu
                    as="div"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <MenuButton className="bg-[#1f1f1f] px-4 py-2 rounded text-white min-w-[150px] flex items-center justify-between">
                      {filter.column || "First Name"}
                      <ChevronDownIcon className="h-5 w-5" />
                    </MenuButton>
                    <MenuItems
                      anchor="bottom start"
                      className="absolute top-full left-0 mt-1 bg-dark-gray border border-border-gray rounded-md shadow-lg"
                      style={{ zIndex: 51 }}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      {tableData.columns.map((column) => (
                        <MenuItem
                          as="div"
                          key={column}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFilterChange(filter.id, "column", column);
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleFilterChange(filter.id, "column", column);
                          }}
                          className="px-4 py-2  text-text-gray hover:bg-[#303030] cursor-pointer whitespace-nowrap"
                        >
                          {column}
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Menu>
                  <Menu>
                    <MenuButton className="bg-[#1f1f1f] px-4 py-2 rounded text-white min-w-[150px] flex items-center justify-between text-nowrap w-[200px] ">
                      {filter.operator}
                      <ChevronDownIcon className="h-5 w-5" />
                    </MenuButton>
                    <MenuItems
                      className="absolute top-full left-0 mt-1 bg-dark-gray border border-border-gray rounded-md shadow-lg"
                      style={{ zIndex: 51 }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      {[
                        "Contains",
                        "Does not contain",
                        "Is",
                        "Is not",
                        "Empty",
                        "Is not empty",
                      ].map((op) => (
                        <MenuItem
                          as="div"
                          key={op}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleFilterChange(filter.id, "operator", op);
                          }}
                          className="px-4 py-2 text-text-gray hover:bg-[#303030] cursor-pointer whitespace-nowrap w-[200px]"
                        >
                          {op}
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Menu>

                  <MenuItem>
                    <input
                      type="text"
                      value={filter.value}
                      onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFilterChange(filter.id, "value", e.target.value);
                      }}
                      placeholder="Enter a value"
                      className="bg-[#1f1f1f] px-4 py-2 rounded text-white border-none focus:outline-none min-w-[200px]"
                    />
                  </MenuItem>

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleRemoveFilter(filter.id);
                    }}
                    className="text-text-gray hover:text-white"
                  >
                    <TrashIcon className="h-5 w-5" />
                  </button>
                </div>
              ))}
            </div>
          </MenuItem>
          <MenuItem>
            <div className="flex gap-4 mt-6">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleAddFilter();
                }}
                className="bg-highlight text-white px-4 py-2 rounded hover:bg-highlight/80 transition-colors"
              >
                Add filter
              </button>
              <button
                onClick={handleResetFilters}
                className="bg-[#1f1f1f] text-text-gray px-4 py-2 rounded hover:bg-[#303030] transition-colors"
              >
                Reset filters
              </button>
            </div>
          </MenuItem>
        </MenuItems>
      </Menu>
    );
  };

  const getFilteredRows = () => {
    return tableData.rows.filter((row) => {
      return filterRows.every((filter) => {
        const value = row.data[filter.column]?.toLowerCase() || "";
        const filterValue = filter.value.toLowerCase();

        switch (filter.operator) {
          case "Contains":
            return value.includes(filterValue);
          case "Does not contain":
            return !value.includes(filterValue);
          case "Is":
            return value === filterValue;
          case "Is not":
            return value !== filterValue;
          case "Empty":
            return value === "";
          case "Is not empty":
            return value !== "";
          default:
            return true;
        }
      });
    });
  };

  useEffect(() => {
    setFilteredRows(getFilteredRows());
    console.log(getFilteredRows());
  }, [filterRows, tableData.rows]);

  return (
    <div className="relative w-[100vw] h-[100vh]">
      <div className="text-2xl font-medium mb-4 bg-dark-gray text-[#fafafa] p-6">
        Ottogrid Clone{" "}
        <span className="font-normal text-text-gray">By Nick Shum</span>
      </div>
      <div className="flex items-center justify-end gap-4 p-4 w-full">
        {/* <FiltersMenu filterRows={filterRows} setFilterRows={setFilterRows} /> */}
        <HiddenColumnsMenu />
      </div>
      <table className="overflow-x-scroll ">
        <thead className="bg-[#1f1f1f] border-y border-border-gray">
          <tr className="sticky top-0 left-0 border-border-gray bg-light-gray ">
            <td className="flex w-[75px] p-4">
              <input
                type="checkbox"
                className=" h-4 w-4 appearance-none cursor-pointer bg-transparent border border-highlight rounded-[4px] checked:bg-highlight  text-white"
                checked={selectedRows.length === tableData.rows.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedRows(tableData.rows.map((row) => row.id));
                  } else {
                    setSelectedRows([]);
                  }
                }}
              />
            </td>
            {tableData.columns.map(
              (column) =>
                !hiddenColumns.includes(column) && (
                  <td
                    key={column}
                    className="border-r h-full w-[300px] border-border-gray bg-light-gray transition-all duration-300 hover:bg-[#303030] text-nowrap text-text-gray hover:text-white whitespace-nowrap"
                  >
                    <ColumnHeaderMenu
                      column={column}
                      onDelete={handleDeleteColumn}
                      onRename={handleRenameColumn}
                    />
                  </td>
                )
            )}
            <td className="border-r h-full border-border-gray bg-light-gray transition-all duration-300 hover:bg-[#303030] text-nowrap text-text-gray text-center hover:text-white  w-[150px]">
              <AddColumnButton />
            </td>
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row, index) => (
            <tr
              key={row.id}
              className={`
                transition-all duration-300
                ${
                  selectedRows.includes(row.id) ? "bg-[#19221e]" : ""
                } text-text-gray`}
              onMouseEnter={() => {
                setHoveredRow(row.id);
              }}
              onMouseLeave={() => {
                setHoveredRow(null);
              }}
            >
              <td className="border-b border-border-gray p-4">
                <div
                  className={`flex items-center justify-between ${
                    hoveredRow === row.id || selectedRows.includes(row.id)
                      ? "hidden"
                      : ""
                  }`}
                >
                  {row.id}
                </div>
                <input
                  type="checkbox"
                  className={`h-4 w-4 appearance-none cursor-pointer bg-transparent border border-highlight rounded-[4px] checked:bg-highlight  text-white ${
                    hoveredRow === row.id || selectedRows.includes(row.id)
                      ? ""
                      : "hidden"
                  }`}
                  checked={selectedRows.includes(row.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedRows([...selectedRows, row.id]);
                    } else {
                      setSelectedRows(
                        selectedRows.filter((id) => id !== row.id)
                      );
                    }
                  }}
                />
              </td>

              {tableData.columns.map(
                (column) =>
                  !hiddenColumns.includes(column) && (
                    <td
                      key={`${row.id}-${column}`}
                      className="h-full border-r border-b border-border-gray"
                    >
                      <input
                        type="text"
                        value={row.data[column] || ""}
                        onChange={(e) =>
                          handleCellEdit(row, column, e.target.value)
                        }
                        onFocus={() => setEditingCell(`${row.id}-${column}`)}
                        onBlur={() => setEditingCell(null)}
                        className={`w-full h-full border-none focus:outline-none focus:bg-none pb-10 pt-3 pl-3  text-top transition-colors duration-300
                        ${
                          editingCell === `${row.id}-${column}`
                            ? "bg-highlight bg-opacity-10"
                            : "bg-transparent"
                        }
                      ${
                        row.data[column] === "Generating..."
                          ? "text-text-gray italic"
                          : ""
                      }`}
                      />
                    </td>
                  )
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Delete buttons column */}

      {/* <div className="ml-2 pt-[52px]">
          {tableData.rows.map((row) => (
            <div key={row.id} className="h-[41px] flex items-center">
              <button
                onClick={() => handleDeleteRow(row.id)}
                className="text-gray-400 hover:text-red-500 px-2"
              >
                ×
              </button>
            </div>
          ))}
        </div> */}

      <button
        className="text-[#fafafa] text-[14px] px-3 py-1 rounded flex items-center transition-all duration-300 hover:bg-[#303030] m-2"
        onClick={() => {
          const emptyRow = {
            id: `${tableData.rows.length + 1}`,
            data: tableData.columns.reduce(
              (acc, col) => ({
                ...acc,
                [col]: "",
              }),
              {}
            ),
          };
          handleAddRow(emptyRow);
        }}
      >
        <span className="text-text-gray text-[18px] mr-3">+</span> New row
      </button>
      {selectedRows.length > 0 && (
        <div className="flex gap-4 items-center fixed bottom-[8px] left-1/2 -translate-x-1/2 justify-center p-2 rounded-lg bg-dark-gray border border-border-gray">
          <div className="flex items-center px-4 py-2 border border-border-gray rounded-lg">
            <div className="text-text-gray border-r border-text-gray pr-4">
              {selectedRows.length} rows selected
            </div>
            <button
              onClick={() => {
                setSelectedRows([]);
              }}
              className="text-text-gray pl-4"
            >
              x
            </button>
          </div>
          <button
            className="bg-[#d03839] text-white px-4 py-2 rounded-lg transition-all duration-300 hover:bg-[#d03839]/80"
            onClick={() => {
              handleDeleteSelected();
            }}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
